import { Construction } from 'lucide-react'

interface PlaceholderProps {
  title: string
  description?: string
}

export function Placeholder({ title, description }: PlaceholderProps) {
  return (
    <div className="view-transition max-w-4xl mx-auto px-10 pt-16 pb-16 text-center">
      <div className="inline-flex w-16 h-16 bg-amber-50 rounded-2xl items-center justify-center mb-5">
        <Construction className="w-8 h-8 text-amber-600" />
      </div>
      <h1 className="font-display text-4xl font-semibold text-navy-700">{title}</h1>
      <p className="text-slate-500 mt-3 max-w-xl mx-auto">
        {description ?? 'Esta sección está en construcción. La armamos en el próximo sprint.'}
      </p>
    </div>
  )
}
